import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";

import App from "./App.tsx";
import { theme } from "./theme";
import { store } from "./store";

import "./index.css";
import { initPostHog } from "./providers/PostHogProvider";
import EmojiProvider from "./components/EmojiProvider";

async function bootstrap() {
  // Silence noisy logs in production
  if (import.meta.env.PROD) {
    try {
      const noop = () => {};
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (console as any).log = noop;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (console as any).debug = noop;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (console as any).trace = noop;
    } catch (_) {
      // no-op
    }
  }

  initPostHog();

  if (import.meta.env.DEV) {
    const { worker } = await import("./mocks/browser.ts");
    await worker.start({
      quiet: true,
      onUnhandledRequest: "bypass",
    });
  }

  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <EmojiProvider>
            <App />
          </EmojiProvider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}

bootstrap();
